module.exports = {
      id: "arrow-down-usage",
      viewBox: "0 0 22.422 26.468",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }